import { FC } from "react";
import {
  StyledImageWrapper,
  StyledInnerWrapper,
  StyledText,
  StyledTextSub,
  StyledTextWrapper,
  StyledWrapper,
} from "./styles";
import { useNavigate } from "react-router-dom";
import { LeftColumnItemProps } from "./types";
import { Avatar } from "@mui/material";
import { stringAvatar } from "./../../../../utils/avatar";
import styles from "./styles.module.scss";

const LeftColumnItem: FC<LeftColumnItemProps> = ({
  id,
  item,
  rows,
}) => {
  const navigate = useNavigate();

  function navigateToUpdatePage(id: string) {
    navigate(`/resources/update/${id}`);
  }

  return (
    <StyledWrapper
      title={item.title + "  " + item.subtitle}
      clickable
      rows={rows}
      onClick={() => navigateToUpdatePage(id)}
    >
      <StyledInnerWrapper>
        <StyledImageWrapper>
          <Avatar 
            className={styles.avatar}
            {...stringAvatar(item.title.toUpperCase())}
          />
        </StyledImageWrapper>
        <StyledTextWrapper>
          <StyledText isMain>{item.title}</StyledText>
          <StyledTextSub>{item.subtitle}</StyledTextSub>
        </StyledTextWrapper>
      </StyledInnerWrapper>
    </StyledWrapper>
  );
};

export default LeftColumnItem;
